import { VFC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Constants from "../../../utils/Constants";

export type ResultResponse = {
  status: string;
  code: string;
  displayMessage: string;
  result: string[];
  errorMessages: [];
};
type Props = {
  isDialogOpen: boolean;
  resultResponse: ResultResponse;
  handler: () => void;
};

/**
 * 処理結果ダイアログ
 * @param param0
 * @returns
 */
export const ResultDialog: VFC<Props> = ({
  isDialogOpen,
  resultResponse,
  handler,
}) => {
  const navigate = useNavigate();
  return (
    <Dialog open={isDialogOpen}>
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>{resultResponse.displayMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          handler();
          if (resultResponse.code === Constants.W_MSG_CODE_SESSION_TIMEOUT) {
            navigate(Constants.NAVI_LOGIN);
          }
        }}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};
